import AnalysisModal from "@/components/AnalysisModal";
import PracticeModal from "@/components/PracticeModal";
import LeaderboardModal from "@/components/LeaderboardModal";
import PerformanceCardModal from "@/components/PerformanceCardModal";
import DefinitionsModal from "@/components/DefinitionsModal";
import JournalModal from "@/components/JournalModal";
import ChallengeModal from "@/components/ChallengeModal";
import JumpToDateModal from "@/components/JumpToDateModal";
import GuildModal from "@/components/GuildModal";
import UserSearchModal from "@/components/UserSearchModal";

/**
 * Container for all the top-level modals the Dashboard owns.
 * Each is rendered conditionally based on its open-state prop.
 */
export default function DashboardModals({
  tradeReview, onCloseTradeReview,
  showPractice, onClosePractice, practiceCtx,
  showLeaderboard, onCloseLeaderboard, leaderboardInitialRange,
  showGuild, tier, onCloseGuild,
  showUserSearch, onCloseUserSearch,
  showPerfCard, stats, tradeHistory, user, onClosePerfCard,
  showDefs, onCloseDefs,
  showJournal, onCloseJournal,
  showChallenge, onCloseChallenge, onChallengeStarted, onChallengeOpenLeaderboard,
  showJumpDate, onCloseJumpDate, periodDays, onJumpToDate,
}) {
  return (
    <>
      {tradeReview && (
        <AnalysisModal trade={tradeReview.trade} analysis={tradeReview.analysis} loading={tradeReview.loading}
          onClose={onCloseTradeReview} />
      )}
      {showPractice && <PracticeModal onClose={onClosePractice} ctx={practiceCtx}/>}
      {showLeaderboard && <LeaderboardModal onClose={onCloseLeaderboard} initialRange={leaderboardInitialRange}/>}
      {showGuild && <GuildModal tier={tier} onClose={onCloseGuild} />}
      {showUserSearch && <UserSearchModal onClose={onCloseUserSearch} />}
      {showPerfCard && <PerformanceCardModal stats={stats} history={tradeHistory} user={user} onClose={onClosePerfCard} />}
      {showDefs && <DefinitionsModal onClose={onCloseDefs} />}
      {showJournal && <JournalModal tier={tier} onClose={onCloseJournal} />}
      {showChallenge && (
        <ChallengeModal onClose={onCloseChallenge} onStarted={onChallengeStarted}
          onOpenLeaderboard={onChallengeOpenLeaderboard}/>
      )}
      {showJumpDate && (
        <JumpToDateModal periodDays={periodDays} onJump={onJumpToDate} onClose={onCloseJumpDate} />
      )}
    </>
  );
}
